// @ts-strict-ignore
import { faExclamationTriangle, faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import type { AviaryColors } from "aviary-tokens";
import type { HTMLAttributes, ReactNode } from "react";

import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";
import * as utilities from "@styles/emotion-styles/utilities";

import * as styles from "./WarningBar.styles";

type WarningBarTypes = Exclude<AviaryColors, "highlight" | "system">;

interface Props extends HTMLAttributes<HTMLDivElement> {
  type: WarningBarTypes;
  children: ReactNode;
  isFixed?: boolean;
  autoHeight?: boolean;
}

const WarningBar = ({ children, type, isFixed = true, autoHeight, ...rest }: Props) => {
  const warningBarStyles = [
    utilities.noprint,
    styles.warningBarContainer.base,
    autoHeight ? styles.responsiveAutoHeight : styles.responsiveHeight,
    isFixed && styles.warningBarContainer.fixed,
    type && styles.warningBarContainer.severity[type],
  ];

  const getIcon = () => {
    if (type === "primary") return faInfoCircle;

    return faExclamationTriangle;
  };

  return (
    <div css={styles.warningBar} {...rest}>
      <div css={warningBarStyles}>
        <div css={styles.warningMessageContainer}>
          <p>
            <FontAwesomeIcon icon={getIcon()} />
            {children}
          </p>
        </div>
      </div>
    </div>
  );
};

export { WarningBar, type WarningBarTypes };
